import React from "react";
import { withTranslation } from "react-i18next";
import { FlexRow, ButtonData } from "../../SummaryList.styled";

const Tabs = (props) => {
  const { t, activeTab, toggleTab } = props;

  return (
    <FlexRow>
      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "centre" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("centre")}
        >
          {t("SITE_SUMMARIES_CENTRES")}
        </ButtonData>
      </div>

      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "haulier" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("haulier")}
        >
          {t("SITE_SUMMARIES_HAULIERS")}
        </ButtonData>
      </div>

      <div>
        <ButtonData
          marginRight="10px"
          color={activeTab === "other" ? "#008395" : "#cccccc"}
          onClick={() => toggleTab("other")}
        >
          {t("SITE_SUMMARIES_OTHER_SERVICES")}
        </ButtonData>
      </div>
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
